import { render, staticRenderFns } from "./LogoUpload.vue?vue&type=template&id=2d0b3f28&scoped=true"
import script from "./LogoUpload.vue?vue&type=script&lang=js"
export * from "./LogoUpload.vue?vue&type=script&lang=js"
import style0 from "./LogoUpload.vue?vue&type=style&index=0&id=2d0b3f28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b3f28",
  null
  
)

export default component.exports